<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar" v-bind:class="{ branded: embed.enabled }">
            <div class="left">
                <v-ons-toolbar-button>
                    <a v-on:click="$router.go(-1)">
                        <i class="fal fa-long-arrow-left"></i>
                    </a>
                </v-ons-toolbar-button>
            </div>
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="right">
                <v-ons-toolbar-button>
                    <a v-on:click="logoutUser" title="Logout" data-test-id="btn-logout">
                        <i class="fal fa-sign-out" aria-hidden="true"></i>
                    </a>
                </v-ons-toolbar-button>
            </div>
        </ons-toolbar>

        <div class="content">
            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <div v-if="has_user" class="content-inner">

                <div class="main-header" data-test-id="txt-header">Your account</div>

                <v-ons-list class="section-h">
                    <v-ons-list-item modifier="chevron" tappable data-test-id="href-orders"
                        v-on:click="$router.push({ name: 'Orders' })">
                        <div class="sub-header">View orders</div>
                    </v-ons-list-item>
                     <v-ons-list-item modifier="chevron" tappable v-show="user.cards_count > 0" data-test-id="href-cards"
                        v-on:click="$router.push({ name: 'PaymentCards' })">
                        <div class="sub-header">View payment cards</div>
                    </v-ons-list-item>
                </v-ons-list>

                <!-- NOTE: ons-list-item inner divs must not be conditional, hence
                     Adding conditionals inside .left, .center, .right-->
                <v-ons-list class="section-h">
                    <div class="sub-header">Your details</div>
                    <v-ons-list-item>
                        <div class="main-text center">
                            <span v-show="editing_email == false">Email</span>
                            <v-ons-input v-show="editing_email" float placeholder="Email" name="email"
                                         v-model="edit_user.email" data-test-id="inp-email"/>
                        </div>
                        <div class="main-text right" v-show="editing_email == false" data-test-id="txt-email">
                          {{ user.email }}
                        </div>
                    </v-ons-list-item>
                    <v-ons-list-item>
                        <div class="main-text center">
                            <span v-show="editing == false">Name</span>
                            <v-ons-input v-show="editing" float placeholder="Name" name="name" v-model="edit_user.name"
                                          data-test-id="inp-name"/>
                        </div>
                        <div class="main-text right" v-show="editing == false" data-test-id="txt-name">
                          {{ user.name }}
                        </div>
                    </v-ons-list-item>
                    <v-ons-list-item>
                        <div class="main-text center">
                            <span v-show="editing == false">Phone</span>
                            <v-ons-input v-show="editing" float placeholder="Phone" name="phone" v-model="edit_user.phone"
                                          data-test-id="inp-phone"/>
                        </div>
                        <div class="main-text right" v-show="editing == false" data-test-id="txt-phone">
                          {{ user.phone }}
                        </div>
                    </v-ons-list-item>
                    <v-ons-list-item v-show="editing && user.social_provider == null">
                        <div class="main-text center">
                            <v-ons-input placeholder="Password - unchanged if blank" name="password" type="password"
                                         float v-model="edit_user.password" data-test-id="inp-password"/>
                        </div>
                    </v-ons-list-item>
                </v-ons-list>

                 <v-ons-list class="section-h">
                    <div class="sub-header">Marketing consent</div>
                    <v-ons-list-item>
                        <div class="center">
                            <span class="main-text">
                                The following options control whether you will receive marketing communications such as
                                emails and SMS messages from the Goodeats platform or stores that you have ordered from.
                                It may take several days for your preferences to take affect.
                            </span>
                        </div>
                    </v-ons-list-item>
                    <!-- Platform content -->
                    <v-ons-list-item>
                        <div class="center">
                            <span class="list-item__title">
                                <label class="main-text pressable">
                                    <v-ons-checkbox v-model="edit_user.opt_in_email" v-bind:disabled="editing == false"/>
                                    Goodeats platform
                                </label>
                            </span>
                            <span class="list-item__subtitle">
                                Marketing such as news and promotions from the Goodeats platform.
                            </span>
                        </div>
                    </v-ons-list-item>
                    <!-- Store consent -->
                    <v-ons-list-item v-if="marketing_consent.length == 0">
                        <div class="center">
                            You will be able to change your marketing consent from each store you've ordered from
                            after placing your first order.
                        </div>
                    </v-ons-list-item>
                    <v-ons-list-item v-for="consent in marketing_consent" v-bind:key="consent.client_id">
                        <div class="center">
                            <span class="list-item__title">
                                <label class="pressable">
                                    <v-ons-checkbox v-model="consent.opt_in_email" v-bind:disabled="editing == false"/>
                                    {{ consent.client_name }}
                                </label>
                            </span>
                            <span class="list-item__subtitle">
                                {{ consent.order_count }} {{ filters.pluralise(consent.order_count, 'order') }}.
                                Last ordered from {{ filters.dateRelative(consent.last_order_at) }}.
                            </span>
                        </div>
                    </v-ons-list-item>
                </v-ons-list>

                <section class="section-vh">
                    <gtc-button v-show="editing == false" v-on:click="editing=true" data-test-id="btn-edit"
                                modifier="large" class="secondary">
                        Edit
                    </gtc-button>
                </section>

                <section class="section-vh">
                    <gtc-button v-show="editing" v-on:click="editing=false" data-test-id="btn-view" modifier="large"
                                class="secondary">
                        View
                    </gtc-button>
                </section>
                <section class="section-vh">
                    <gtc-button v-show="editing" v-on:click="updateProfile" data-test-id="btn-save" modifier="large"
                                class="btn-action">
                        Save changes
                    </gtc-button>
                </section>

                <v-ons-list class="section-h" data-test-id="cnt-addresses">
                    <div class="sub-header">Addresses</div>
                    <v-ons-list-item v-if="user.addresses.length == 0">
                        <div class="main-text center">No addresses</div>
                    </v-ons-list-item>
                    <v-ons-list-item v-for="address in user.addresses" v-bind:key="address.id"
                                     v-on:click="viewAddress(address.id)" modifier="chevron" tapabale>
                        <div class="main-text center">
                            {{ address.address }}, {{ address.postcode }}
                        </div>
                    </v-ons-list-item>
                    <section class="section-vh">
                        <gtc-button v-on:click="addAddress" class="btn-action" data-test-id="btn-address-add">
                            Add address
                        </gtc-button>
                    </section>
                </v-ons-list>

                <section class="section-vh" v-show="show_dev_features">
                    <gtc-button v-on:click="deleteAccount" class="primary">
                        Delete account
                    </gtc-button>
                    <p class="warning-text text-centre">This option is not available in production.</p>
                </section>

                <section class="section-vh" v-show="show_dev_features">
                    <gtc-button v-on:click="unverifyAccount" class="primary">
                        Un-verify account
                    </gtc-button>
                    <p class="warning-text text-centre">This option is not available in production.</p>
                </section>


            </div>

        </div>

        <address-picker v-bind:show="show_add_address_dlg"
                        v-on:savedAddress="addAddressSubmit"
                        v-on:show="show => show_add_address_dlg = show"></address-picker>

        <validation v-bind:show="validation.show"
                    v-bind:errors="validation.errors"
                    v-on:show="(show) => validation.show = show"></validation>

    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'
    import GoogleMapsLoader from 'google-maps'

    import { default as ValidationComponent } from '../fragments/validation'
    import { default as AddressPicker } from '../fragments/address_picker'

    export default {

        components: {
            'validation': ValidationComponent,
            'address-picker': AddressPicker,
        },

        data () {
            return {
                app: this.$root.$data.app,
                user: null,
                edit_user: {
                    name: '',
                    email: '',
                    password: null,
                    phone: null,
                    opt_in_email: null,
                    marketing_consent: null,
                },
                validation: {
                    show: false,
                    errors: null,
                },
                show_add_address_dlg: false,
                editing: false,
                saving: false,
            }
        },

        mounted(){
            this.getUserData()
        },

        methods: {

            ...mapMutations([
                'logout',
            ]),

            getUserData() {
                this.app.http.get('user')
                    .then(response => {
                        this.user = response.data.user
                        this.user.marketing_consent = response.data.marketing_consent
                        this.edit_user = {
                            name: this.user.name,
                            email: this.user.email,
                            password: '',
                            phone: this.user.phone,
                            opt_in_email: this.user.opt_in_email,
                            marketing_consent: this.helpers.deepCopy(this.user.marketing_consent),
                        }
                    })
                    .catch(error => {
                        this.app.logException(new Error('Failed to get user.'), { error })
                        this.$router.push(this.app.homeRoute())
                        this.$ons.notification.alert(
                            this.app.getResponseErrorMessage(error),
                            { title: 'Unable to fetch profile data'}
                        )
                    })
            },

            logoutUser(event){

                if (event)
                    event.preventDefault()

                this.$router.push({ name: 'Outlets' })
                this.logout()
                this.$ons.notification.toast('You have logged out', { timeout: 1000 })
            },

            updateProfile(){

                this.saving = true

                this.edit_user.phone = this.filters.noSpace(this.edit_user.phone)

                const data = Object.assign({}, this.edit_user)
                if (data.password != null && data.password.length == 0)
                    delete data['password']

                this.app.http.patch('user', data)
                    .then(response => {
                        this.saving = false
                        this.getUserData()
                        this.editing = false

                        this.$ons.notification.toast('Your profile has been updated', { timeout: 1000 })
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            if (error.response.data.hasOwnProperty('errors')){
                                this.validation.errors = Object.values(error.response.data.errors).map(e => e[0])
                                this.validation.show = true
                            } else {
                                this.$ons.notification.alert(
                                    this.app.getResponseErrorMessage(error),
                                    {title: 'Unable to update profile'}
                                )
                            }
                        }
                        this.saving = false
                    })
            },

            addAddress(){
                this.show_add_address_dlg = true
            },

            addAddressSubmit(data){
                this.app.http.post('user/address', data)
                    .then(response => {
                        this.show_add_address_dlg = false
                        this.user.addresses = response.data.user.addresses
                    })
                    .catch(error => {
                        if (error.response.data.hasOwnProperty('errors')){
                            this.validation.errors = Object.values(error.response.data.errors).map(e => e[0])
                            this.validation.show = true
                        }
                    })
            },

            viewAddress(id){
                this.$router.push({ name: 'Address', params: { address_id: id }})
            },

            deleteAccount(){
                this.app.http.delete('user')
                    .then(response => {
                        this.$ons.notification.alert('Your account has been deleted!')
                        this.logoutUser()
                    })
                    .catch(error => {

                    })
            },

            unverifyAccount(){
                this.app.http.post('user/unverify')
                    .then(response => {
                        this.$ons.notification.alert(response.data.message)
                        this.logoutUser()
                    })
                    .catch(error => {
                        this.$ons.notification.alert(this.app.getResponseErrorMessage(error))
                    })
            },
        },

        computed: {
            ...mapGetters([
                'embed',
            ]),

            has_user: function(){
                return this.user != null
            },

            show_loading: function(){
                return this.user == null || this.saving
            },

            editing_email: function(){
                if (this.user == null)
                    return false

                return this.editing && this.user.social_provider == null
            },

            marketing_consent: function(){

                if (this.user == null || this.user.marketing_consent == null)
                    return []

                return this.editing ? this.edit_user.marketing_consent : this.user.marketing_consent
            },

            can_save_address: function(){
                return [
                    this.new_address.address,
                    this.new_address.city,
                    this.new_address.postcode
                ].filter(x => x && x.length > 0).length == 3
            },

            show_dev_features: function(){
                return window.env.environment != 'prod'
            },
        },

        watch: {
          '$route': function(to, from){

                if(to.name == 'User')
                    this.getUserData()
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/user/show.vue